import { useEffect, useState } from 'react';
import MyUploadMediaInputWithUrl from '../components/ui/MyUploadMediaInputWithUrl';
import MyInput from '../components/ui/MyInput';
import onboarding_4_2 from '../assets/img/phoneMockUp.png';
import defaultIcon from '../assets/img/default_icon.png';
import CreateAction from '../components/operational/createAction';
import { useDispatch } from 'react-redux';
import myAppsSlice from '../redux/myAppsSlice';
import { useNavigate } from 'react-router-dom';
import SecondaryButton from '../components/ui/SecondaryButton';
import { useSelector } from 'react-redux';

const CreateApp = () => {
  const [error, setError] = useState([]);
  const [uploadedPhoto, setUploadedPhoto] = useState('');
  const [appName, setAppName] = useState('');
  const [website, setWebsite] = useState('');
  const [subdomain, setSubdomain] = useState('');
  const [selectedProvider, setSelectedProvider] = useState('IKAS_WEBVIEW');
  const stores = useSelector(state => state.myAppsSlice.localReduxData.stores);

  const dispatch = useDispatch();
  const [clientData, setClientData] = useState({
    client_id: '',
    client_secret: '',
  });
  const navigate = useNavigate();

  const appNameToSubdomainName = appName => {
    const replacements = {
      ç: 'c',
      ğ: 'g',
      ı: 'i',
      i: 'i',
      ö: 'o',
      ş: 's',
      ü: 'u',
      Ç: 'C',
      Ğ: 'G',
      İ: 'I',
      Ö: 'O',
      Ş: 'S',
      Ü: 'U',
    };

    return appName
      .replace(/[çğıiöşüÇĞİÖŞÜ]/g, char => replacements[char] || char)
      .toLowerCase()
      .replace(/ /g, '-');
  };
  const acceptedImages = {
    'image/png': ['.png'],
    'image/jpg': ['.jpg'],
  };
  const saveConditions = [
    {
      check: !appName,
      error: 'appName',
    },
    {
      check: !website,
      error: 'website',
    },
    {
      check: !uploadedPhoto,
      error: 'uploadedPhoto',
    },
    {
      check: !subdomain,
      error: 'subdomain',
    },
  ];
  const clientSaveConditions = [
    {
      check: !selectedProvider?.includes('_WEBVIEW') && !clientData.client_id,
      error: 'client_id',
    },
    {
      check: !selectedProvider?.includes('_WEBVIEW') && !clientData.client_secret,
      error: 'client_secret',
    },
  ];
  const errorGenerator = newError => {
    setError(state => {
      const newState = [...state];
      newState.push(newError);
      return newState;
    });
    return true;
  };
  const errorChecker = conditions => {
    setError([]);
    const failedCondition = conditions.filter(condition => {
      const check = condition.check;
      if (check) return errorGenerator(condition.error);
    });
    if (failedCondition.length > 0) return true;
  };

  const handleClickContinueButton = async e => {
    const createError = errorChecker(saveConditions);
    if (createError) return null;

    const storeId = localStorage.getItem('activeStoreId');
    let data = {
      mobileAppName: appName,
      domain: website,
      appLogo: uploadedPhoto,
      mobligoSubdomain: subdomain,
      providerData: clientData,
      provider: selectedProvider,
    };

    const response = await CreateAction({
      isCreateNewApp: { duration: 4000 },
      method: 'post',
      data,
      path: '/store',
      headers: {
        'Mobligo-StoreId': storeId,
      },
      showPreLoader: true,
      isFileUploading: false,
    });
    if (response?.error) {
      return;
    }

    localStorage.setItem('activeStoreId', response?.result?.resultData?.id);
    dispatch(
      myAppsSlice.actions.setLocalReduxData({
        app: response?.result?.resultData,
      }),
    );

    window.location.pathname = '/dashboard';
  };

  return (
    <div
      className="w-full h-full overflow-auto scrollbar-y-visible"
      style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
    >
      <div className="fixed w-full padding-[55px] top-0 left-0 flex justify-between flex-row p-[55px] items-center">
        <img src={process.env.REACT_APP_LOGO} className="w-[261px]"></img>
        <div>
          <SecondaryButton
            classes=""
            value={stores?.length > 0 ? 'Geri Dön' : 'Çıkış Yap'}
            onClick={() => {
              if (stores?.length > 0) {
                navigate(-1);
                return;
              }
              localStorage.clear();
              navigate('/');
            }}
          ></SecondaryButton>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
        <div className="flex items-center justify-center text-[#5Es5873] h-[40px] text-[12px] font-bold">
          <h2 className="text-[18px] pl-[26px]">{'Yeni Uygulama Oluştur'}</h2>
        </div>
        <div className="w-[60%] flex flex-row p-[30px]">
          <div className="w-[65%] flex flex-row center">
            <div className="h-[100%] w-[100%] flex flex-col  ">
              <div className="flex flex-row h-[100px] ">
                <div className="w-[100px] shrink-0  flex flex-col items-center">
                  <MyUploadMediaInputWithUrl
                    accept={acceptedImages}
                    imageHeight={'100%'}
                    preImage={uploadedPhoto}
                    error={error.includes('uploadedPhoto')}
                    obJectFit="1/1"
                    className="w-[20px] h-[100px]"
                    onChange={item => setUploadedPhoto(item)}
                  />
                </div>
                <div className="w-full flex justify-start items-center flex-row">
                  <div className="flex-col flex mx-3 gap-[2px]">
                    <div className="text-[#5E5873] text-[16px]">Uygulama İkonu</div>
                    <div className="text-[#8A92A6] text-[12px]">Görsel Boyutu:</div>
                    <div className="text-[#8A92A6] text-[12px] mt-[-5px]">Saydam olmayan bir görüntü kullanın.</div>
                    <div className="text-[#8A92A6] text-[12px] mt-[-5px]"> Önerilen boyut: 512x512 px</div>
                  </div>
                </div>
              </div>

              <div className=" w-[100px] text-center text-[12px] break-words mt-1">{appName}</div>

              <div className={`w-[100%] flex flex-col gap-4 box-border mt-[50px]`}>
                <div className="flex flex-col clearLabel">
                  <span className="block text-[#8A92A6] text-[14px]">Uygulama İsmi:</span>
                  <MyInput
                    isError={error?.includes('appName')}
                    isErrorMessage={'Uygulama ismi giriniz.'}
                    labelViaPlaceholder={false}
                    type="text"
                    color="black"
                    onChange={e => {
                      setAppName(e);
                      setSubdomain(appNameToSubdomainName(e));
                    }}
                    placeholder="Uygulama İsmi"
                    value={appName}
                    maxLength={30}
                  />
                </div>

                <div className="flex flex-col ">
                  <span className="block  text-[#8A92A6] text-[14px]">Website Linki:</span>
                  <MyInput
                    isError={error?.includes('website')}
                    isErrorMessage={'Website adresi giriniz.'}
                    labelViaPlaceholder={false}
                    type="text"
                    color="black"
                    onChange={e => setWebsite(e)}
                    label=""
                    value={website}
                  />
                </div>

                <div className="flex flex-col ">
                  <span className="block text-[#8A92A6] text-[14px]">Paneliniz:</span>
                  <div className="text-[#7059EF] clearLabel relative">
                    <MyInput
                      isError={error?.includes('subdomain')}
                      isErrorMessage={'Panel adı giriniz.'}
                      value={subdomain}
                      onChange={e => {
                        setSubdomain(appNameToSubdomainName(e));
                      }}
                    />
                    <div className="absolute right-2 top-1 bottom-0 h-[40px] border-l pl-[5px] bg-[white] flex items-center">
                      .mymobligo.com
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="relative w-[35%] flex items-center justify-center ">
            <div className="w-[200px] h-[407.17px] relative m-auto">
              <img src={onboarding_4_2} className="h-full" />
              <div className="absolute w-full h-full top-0 left-0">
                <img
                  src={uploadedPhoto || defaultIcon}
                  className="absolute top-[180px] left-[145px] w-[33px] h-[33px] rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          onClick={handleClickContinueButton}
          className="cursor-pointer bg-[#7059EF] mt-[20px] text-white break-words font-semibold text-[12px] md:font-[15px] w-[200px] h-[50px] flex justify-center items-center rounded hover:bg-[#5841D9] ml-3"
        >
          Mağaza Oluştur
        </div>
      </div>
    </div>
  );
};

export default CreateApp;
